<div class="open-hours">
    <div class="open-hours__inner">
        <ul class="open-hours__list">
            <ng-container *ngIf="openHours && openHours?.length > 0">
                <li class="open-hours__li" [ngClass]="{'is-active': open.DayOfWeek === currenWeekDay}"
                    *ngFor="let open of openHours;trackBy: trackBy">
                    <label class="open-hours__label">
                        {{open.DayOfWeek | appDayName}}
                    </label>

                    <div class="open-hours__value" *ngIf="open.IsOpen">
                        <span class="open-hours__open">
                            {{open.OpeningTime | appHours}}
                        </span>
                        <span class="open-hours__sep"> - </span>
                        <span class="open-hours__close">
                            {{open.ClosingTime | appHours}}
                        </span>
                    </div>

                    <div class="open-hours__value" *ngIf="!open.IsOpen">
                        closed
                    </div>

                </li>
            </ng-container>
        </ul>
    </div>
</div>